import React from 'react'
import moment from 'moment'
import { isEmpty } from 'lodash'
import { Popover } from 'react-tiny-popover'

import {
  calendarCellDateFormat as dateFormat,
  calendarCellMaxEvents as maxCellEvents,
} from '../../../configuration/configs'
import DateCellPopoverContent from './DateCellPopoverContent'
import labels from '../../../configuration/labels'

const CalendarDateCell = ({
  currentDate,
  day,
  openEventsPopover,
  closeEventsPopover,
  renderCellEvents,
  renderPopoverEvents,
  selectedDate,
}) => {
  const cloneDay = day
  const formattedDate = moment(day).format(dateFormat)
  function getDateCellClassName() {
    if (!moment(day).isSame(currentDate, 'month')) return 'disabled'
    if (moment(day).isSame(selectedDate, 'day') && !isEmpty(renderCellEvents))
      return 'selected inc-events'
    if (!isEmpty(renderCellEvents)) return 'inc-events'
    return ''
  }
  const dateCellClassName = getDateCellClassName()

  const renderEvents =
    renderCellEvents && !isEmpty(renderCellEvents) && moment(day).isSame(currentDate, 'month')

  return (
    <div key={day} className={`u-calendar__date-cell ${dateCellClassName}`}>
      <span className="date-number">{formattedDate}</span>
      {renderEvents && (
        <div className="u-calendar__date-events">
          <div className="event-entries">{renderCellEvents.slice(0, maxCellEvents)}</div>

          <Popover
            isOpen={moment(day).isSame(selectedDate, 'day')}
            containerClassName="decoupled-events-popover calendar-date-cell"
            containerParent={document.getElementById('decoupled-events')}
            containerStyle={{ zIndex: 3 }}
            position={['top']}
            padding={10}
            onClickOutside={closeEventsPopover}
            content={() => (
              <DateCellPopoverContent
                day={day}
                closeEventsPopover={closeEventsPopover}
                renderPopoverEvents={renderPopoverEvents}
                selectedDate={selectedDate}
              />
            )}
          >
            <button
              className="btn btn-text event-entries__popover-toggle"
              onClick={
                moment(day).isSame(selectedDate, 'day')
                  ? closeEventsPopover
                  : () => openEventsPopover(cloneDay)
              }
            >
              <span className="desktop">{labels.calendarCtaViewAllEvents}&nbsp;</span>
              <span className="mobile">{labels.calendarCtaView}&nbsp;</span>
              <span>
                {renderCellEvents.length > maxCellEvents && `(${renderCellEvents.length})`}
              </span>
            </button>
          </Popover>
        </div>
      )}
    </div>
  )
}

export default CalendarDateCell
